export const firebaseConfig = {
  apiKey: "AIzaSyAVjdzXeGDu2WcWK9oWB5FM_JBGakErUWA",
  authDomain: "lumir-push-notification.firebaseapp.com",
  projectId: "lumir-push-notification",
  storageBucket: "lumir-push-notification.firebasestorage.app",
  messagingSenderId: "775420248794",
  appId: "1:775420248794:web:94e77a9647380656d9dbe3",
  measurementId: "G-JL5SDSV7T1"
};

export const vapidKey = "BF-mA6CgqaVVM884uY-yLU8bW08qABRtYo8hSzdB6b53MPdlVNENwERj8w_kb4S4zu4LxyIyNogrGsaeTSX7ACw";